import { render, staticRenderFns } from "./AddBuyModal.vue?vue&type=template&id=2253f207&"
import script from "./AddBuyModal.vue?vue&type=script&lang=js&"
export * from "./AddBuyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports